<template>
  <component :is="tag" :class="['airtable-html', tagClass]" v-html="html" />
</template>

<script>
import { mapGetters } from 'vuex'

import getHTMLfromContent from '@/utils/getHTMLfromContent'

export default {
  name: 'AirtableHtml',
  props: {
    settingName: {
      type: String,
      default: '',
      require: true,
    },
    tag: {
      type: String,
      default: 'div',
    },
    tagClass: {
      type: String,
      default: '',
    },
  },
  components: {},
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
    html() {
      let airtableContent = this.getShopDetail(this.settingName)
      return airtableContent ? getHTMLfromContent(airtableContent) : ''
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
@import '@/scss/variables.scss';

.airtable-html {
  font-size: 1.2rem;
  line-height: 1.5;
  color: rgb(30, 30, 30);
  // font-size: 1.2rem;
  // line-height: 1.3;
  // font-weight: normal;
  font-family: $body-font-family;
  h1,
  h2,
  h3,
  p,
  ul,
  ol,
  pre,
  blockquote {
    margin: 1rem 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1,
  h2,
  h3 {
    line-height: 1.3;
  }
}
</style>
